import { useEffect } from "react";
import { api } from "@/api";
import { toast } from "sonner";

const enc = encodeURIComponent;
const AUTOSCROLL_MARGIN_PX = 100;
const AUTOSCROLL_STEP_PX = 14;

export function useDragAutoscroll() {
  useEffect(() => {
    const onDragOver = (e) => {
      if (!e.dataTransfer?.types?.includes("application/x-person")) return;
      if (e.clientY < AUTOSCROLL_MARGIN_PX) window.scrollBy(0, -AUTOSCROLL_STEP_PX);
      else if (e.clientY > window.innerHeight - AUTOSCROLL_MARGIN_PX) window.scrollBy(0, AUTOSCROLL_STEP_PX);
    };
    window.addEventListener("dragover", onDragOver);
    // listener globale registrato una sola volta: nessuna dipendenza da state
    return () => window.removeEventListener("dragover", onDragOver);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}

export function useSiteReorder(monthKey, dayNum, data, setData, load) {
  const moveSite = async (sourceName, targetName) => {
    if (!data || sourceName === targetName) return;
    const next = [...data.sites];
    const from = next.findIndex((s) => s.name === sourceName);
    const to = next.findIndex((s) => s.name === targetName);
    if (from < 0 || to < 0) return;
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);
    setData({ ...data, sites: next });
    try {
      await api.put(`/months/${enc(monthKey)}/days/${dayNum}/sites-order`, { names: next.map((s) => s.name) });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore riordino cantieri");
      load();
    }
  };
  return moveSite;
}
